(function () {
  var paymentTermsSelector = 'shopify-payment-terms';
  var styleSelector = 'style[data-xtra-installments-font]';
  var fontStyles = [
    '#shopify-installments,',
    '#shopify-installments-content {',
    "  font-family: 'Poppins', sans-serif !important;",
    '}',
  ].join('\n');

  function applyInstallmentsFont(paymentTerms, attempt) {
    if (!paymentTerms || !paymentTerms.isConnected) return;

    var shadowRoot = paymentTerms.shadowRoot;

    if (!shadowRoot) {
      if ((attempt || 0) < 120) {
        requestAnimationFrame(function () {
          applyInstallmentsFont(paymentTerms, (attempt || 0) + 1);
        });
      }

      return;
    }

    if (shadowRoot.querySelector(styleSelector)) return;

    var style = document.createElement('style');
    style.setAttribute('data-xtra-installments-font', '');
    style.textContent = fontStyles;
    shadowRoot.appendChild(style);
  }

  function scanForPaymentTerms(root) {
    if (!root) return;

    if (root.matches && root.matches(paymentTermsSelector)) {
      applyInstallmentsFont(root, 0);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(paymentTermsSelector).forEach(function (paymentTerms) {
        applyInstallmentsFont(paymentTerms, 0);
      });
    }
  }

  customElements.whenDefined(paymentTermsSelector).then(function () {
    scanForPaymentTerms(document);
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          scanForPaymentTerms(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
